import "./contact.css";
import contact from "../../assets/contact-me.svg";
import framer1 from "../../assets/mikke.jpg";
import framer2 from "../../assets/Frame1.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import {
  faGithub,
  faInstagram,
  faLinkedin,
  faMailchimp,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

const buttonVariants = {
  tap: {
    scale: 0.9,
    rotate: [0, -5, 5, -5, 5, 0],
    transition: {
      duration: 0.5,
    },
  },
};
function Contact() {
  return (
    <div className="contact__container">
      <div className="cont__image">
        <img src={contact} alt="" />
      </div>
      <div className="cont">
        <h2 className="contact__title">Contact</h2>
        Have an idea to discuss? Shoot me an email if you want to connect! You
        can also find me on Linkedin if that's more your speed.
      </div>
      <div className="socials-about">
        <motion.div
          className="social-media"
          variants={buttonVariants}
          whileHover="tap"
        >
          <a href="https://www.instagram.com/mikey_mbugua/" target="_blank">
            <FontAwesomeIcon icon={faInstagram} color="#9ab5e7" size="2xl" />
          </a>
          instagram
        </motion.div>
        <motion.div
          className="social-media"
          variants={buttonVariants}
          whileHover="tap"
        >
          <a href="https://twitter.com/MichaelKamiri2" target="_blank">
            <FontAwesomeIcon icon={faTwitter} color="#9ab5e7" size="2xl" />
          </a>
          Twitter
        </motion.div>
        <motion.div
          className="social-media"
          variants={buttonVariants}
          whileHover="tap"
        >
          <a href="https://www.github.com/mike-mbugua" target="_blank">
            <FontAwesomeIcon icon={faGithub} color="#9ab5e7" size="2xl" />
          </a>
          Github
        </motion.div>
        <motion.div
          className="social-media"
          variants={buttonVariants}
          whileHover="tap"
        >
          <a
            href="https://www.linkedin.com/in/michael-kamiri-mbugua/"
            target="_blank"
          >
            <FontAwesomeIcon icon={faLinkedin} color="#9ab5e7" size="2xl" />
          </a>
          LinkedIn
        </motion.div>
      </div>
    </div>
  );
}

export default Contact;
